import { render, staticRenderFns } from "./ProtocoloDetalhes.vue?vue&type=template&id=de036bd8&scoped=true&"
import script from "./ProtocoloDetalhes.vue?vue&type=script&lang=js&"
export * from "./ProtocoloDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ProtocoloDetalhes.vue?vue&type=style&index=0&id=de036bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de036bd8",
  null
  
)

export default component.exports